<template>
<v-expansion-panels v-model="panel" multiple>
    <v-expansion-panel>
        <v-expansion-panel-header class="px-1 d-flex justify-space-between">
            <template v-slot:default="{ open }">
                <div class="px-2">
                    <span v-if="room.name">
                        {{ room.name }}
                    </span>
                    <span v-else>
                        {{ $t('room_type_slug.' + room.slug) }}
                    </span>
                </div>
                <v-fade-transition leave-absolute>
                    <div v-if="!open" class="text-right">
                        <v-chip small>
                            <span class="regular">{{rate_plans.length}}/{{rate_plans_length}} selectate</span>
                        </v-chip>
                    </div>
                </v-fade-transition>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <div v-for="rate_plan in room.rate_plans" :key="rate_plan.id" class="pa-1">
                <template v-if="!rate_plan.stop_sell&&(rate_plan.net_prices==net_price)">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="rate_plans" :value="rate_plan.id" :label="rate_plan.name" :disabled="rate_plan.component_based||(!!rate_plan.parent_id)" @change="setRatePlan()" />
                    <div v-if="!!rate_plan.parent_id" class="px-2 detail">
                        Plan extins
                        <span class="faded">(*se va modifica doar planul de baza)</span>
                    </div>
                    <div v-if="rate_plan.component_based" class="px-2 detail">
                        Plan bazat pe tarife individuale
                    </div>
                </template>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</template>
<script>
export default {
    props: {
        room: Object,
        net_price: Boolean,
    },
    data() {
        return {
            panel: [],
            rate_plans: [],

        }
    },

    computed: {
        rate_plans_length() {
            let array = this.room.rate_plans.filter(item => !item.stop_sell && (item.net_prices == this.net_price))

            return array.length

        }
    },


    methods: {
        setRatePlan() {
            this.$emit('change', [this.room.id, this.rate_plans]);
        },



        clean() {
            this.rate_plans = [];
            this.panel = [];
        }
    },
}
</script>
